var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnifiedAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.55 76.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-unified-analytics--lg-1",
    x1: 9.12,
    x2: 32.83,
    y1: 54.1,
    y2: 54.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41d3bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a8aee"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-unified-analytics--lg-2",
    x1: 48.47,
    x2: 18.13,
    y1: 31.13,
    y2: 61.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a8aee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401ab0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-unified-analytics--lg-3",
    x1: 33.53,
    x2: 64.45,
    y1: 57.44,
    y2: 26.53,
    xlinkHref: "#ss-unified-analytics--lg-2"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss-unified-analytics--lg-4",
    x1: 69.91,
    x2: 49.13,
    y1: 22.78,
    y2: 58.78,
    xlinkHref: "#ss-unified-analytics--lg-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a8aee",
    d: "M46.18 10.73l-26.77 7.18a7 7 0 00-4.95 4.95L7.28 49.63A7 7 0 009.1 56.4L28.69 76a7 7 0 006.77 1.82l26.77-7.18a7 7 0 005-4.95l7.18-26.77a7 7 0 00-1.82-6.77L53 12.55a7 7 0 00-6.82-1.82z",
    transform: "translate(-7.05 -1.95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-unified-analytics--lg-1)",
    d: "M12.09 31.71l-3 11.06 5 18.65L28.69 76a6.89 6.89 0 004.14 2L20.55 32.18s-.82-2.52-3.24-1.87z",
    opacity: 0.94,
    transform: "translate(-7.05 -1.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-unified-analytics--lg-2)",
    d: "M19.41 17.91l12.49-3.35L48 74.46l-12.5 3.35a8.4 8.4 0 01-.83.17l-16-59.8s.48-.18.74-.27z",
    transform: "translate(-7.05 -1.95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-unified-analytics--lg-3)",
    d: "M34 14l12.23-3.28a6.85 6.85 0 012.25-.22l15.81 59.2a7.08 7.08 0 01-2.06.93L50 73.91z",
    transform: "translate(-7.05 -1.95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ss-unified-analytics--lg-4)",
    d: "M54 13.57l14.52 14.55 4.37 16.29-5.71 21.27a7.85 7.85 0 01-1.41 2.71L52 16.85a2.66 2.66 0 012-3.28z",
    opacity: 0.94,
    transform: "translate(-7.05 -1.95)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11 32.51a2.63 2.63 0 00-1.87 3.24l1.88 7 3-11.06zM31.9 14.56l-.1-.39a2.63 2.63 0 00-3.24-1.87l-8.2 2.2s-2.59.55-1.75 3.68zM36.09 4l-2 .52a2.6 2.6 0 00-1.87 3.24L34 14l12.23-3.28a8.17 8.17 0 012.25-.22l-1.82-6.6A2.65 2.65 0 0043.42 2zM56.57 12.88l4.79-1.29a2.64 2.64 0 013.23 1.87l3.93 14.66L54 13.57z",
    fill: "#41d3bd",
    transform: "translate(-7.05 -1.95)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifiedAnalytics);
export default __webpack_public_path__ + "static/media/unified-analytics.85f7893e.svg";
export { ForwardRef as ReactComponent };